import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-textarea-field',
  templateUrl: './textarea-field.component.html',
  styleUrls: ['./textarea-field.component.css']
})
export class TextareaFieldComponent {
  @Input() id: string;
  @Input() controlName: string;
  @Input() readonly = false;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() class = 'field';
  @Input() rows: number;
  @Input() cols: number;
  @Input() hideErrors = false;
  @ViewChild('error') error;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/forms/textarea-field/textarea-field.component.ts